/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description listablesReducer
 */

import { DEFAULT_LISTABLES } from '@zcode/nr/es/shared/bizos/listables'
import { combineActions, handleActions } from 'redux-actions'

import {
  GET_LISTABLES_SUCCESS,
  HIDE,
  RESET_LISTABLES,
  RESET_SAVED_SEARCHES_VIEW,
  RESET_SELECTED_SAVED_SEARCH,
} from '../constants/index'

const listablesReducer = handleActions(
  {
    [GET_LISTABLES_SUCCESS]: (state, action) => {
      const { payload } = action
      if (payload) {
        const { listables } = payload

        return {
          ...listables,
          listables: [...listables.listables, ...state.listables.concat(listables.listables)],
          featured: [...listables.featured, ...state.featured.concat(listables.featured)],
        }
      }
      return state
    },
    [combineActions(HIDE, RESET_LISTABLES, RESET_SAVED_SEARCHES_VIEW, RESET_SELECTED_SAVED_SEARCH)]:
      () => DEFAULT_LISTABLES,
  },
  DEFAULT_LISTABLES
)

export default listablesReducer
